<h1 mat-dialog-title>{{ title | translate }}</h1>
<div mat-dialog-content [innerHtml]="messageHtml"></div>
<div mat-dialog-actions>
  <span fxFlex></span>
  <button
    mat-button
    color="primary"
    ixTest="close-dialog"
    (click)="dialogRef.close(true)"
  >
    {{ 'Close' | translate }}
  </button>
</div>
